<template>
    <div class="checkout-information">
        <div class="checkout-information__block">
            <order-coupon
                :result="result"
                :jsData="jsData"
                @setAjax="$emit('setAjax')"
            />
        </div>
        <div class="checkout-information__block">
            <h5 class="def-title-5">{{ result.messages.orderInfo }}</h5>
            <a v-if="!thanksPage" :href="result.routes.basket.path" class="def-link">
                <svg>
                    <use xlink:href="#svg-arrow-left-blue"></use>
                </svg>
                {{ result.routes.basket.backToBasket }}
            </a>
            <div v-if="result.items">
                <checkout-goods v-for="item in result.items" :result="item" :key="item.id" />
            </div>
        </div>
        <div class="checkout-information__block">
            <order-total :result="result" :total="total"/>
        </div>
        <div class="checkout-information__grid" :class="{'checkout-information__grid-thanks': thanksPage}">
            <div class="checkout-information__block">
                <p v-if="result.messages.infoWarranty" class="checkout-guarantee">
                    <svg><use xlink:href="#svg-completed"></use></svg>
                    {{ result.messages.infoWarranty }}
                </p>
                <p v-if="result.messages.infoReturn" class="checkout-guarantee">
                    <svg><use xlink:href="#svg-arrow-return"></use></svg>
                    {{ result.messages.infoReturn }}
                </p>
            </div>
            <!--
            <div v-if="screenWidth >= 768 && !thanksPage && result.routes.buyOneClick" class="checkout-information__block">
                <buy-one-click :result="result.routes.buyOneClick" />
            </div>
            -->
        </div>
    </div>
</template>

<script>


// const item = require('../../../MOCKED_DATA/good-item').goodItem;
// const totalPrice = require('../../../MOCKED_DATA/total-price').totalPrice;

export default {
        name: 'checkout-information',
        props: {
            result: {
                type: Object,
                default: () => {
                    return {
                        ...totalPrice,
                        items: [
                            {...item, id: 1},
                            {...item, id: 2}
                        ],
                        messages: {
                            // ...totalPrice.messages,
                            orderInfo: 'Інформація про замовлення',
                            routes: {
                                basket: {
                                    path: '#',
                                    backToBasket: 'Редагувати замовлення'
                                }
                            }
                        },
                    }
                }
            },
            jsData: {
                type: Object,
            },
            total: {
                type: Object,
            },
            thanksPage: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
            }
        },
        mounted() {
            if (App.debug) {
                console.log('Component: checkout-information', this.result);
            }
        }
}
</script>

<style lang="scss">
    .checkout-information{
        &__block{
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #fff;
            padding: 16px;
            //&:not(:last-child) {
                margin-bottom: 4px;
            //}
            @include point-md{
                padding: 24px;
            }
        }
        .checkout-information__grid-thanks{
            .checkout-information__block{
                margin-bottom: 0;
            }
        }
        &__grid:not(.checkout-information__grid-thanks){
            display: grid;
            grid-template-columns: 1fr;
            @include point-md{
                grid-template-columns: repeat(2, 1fr);
                grid-column-gap: 4px;
            }
            @include point-lg{
                grid-template-columns: 1fr;
            }
        }
        .def-title-5{
            margin-bottom: 8px;
        }
        .def-link{
            font-weight: 500;
            font-size: rem(12);
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: var(--text-colour-secondary);
            svg{
                width: 8px;
                height: 8px;
                fill: var(--border-colour-primary);
                margin-right: 4px;
            }
        }
    }
    .checkout-guarantee{
        display: flex;
        align-items: center;
        font-size: rem(14);
        line-height: 110%;
        color: #757575;
        @include point-md{
            font-size: rem(16);
        }
        &:not(:last-child) {
            margin-bottom: 16px;
        }
        svg{
            width: 16px;
            height: 16px;
            margin-right: 8px;
        }
    }
</style>